var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 3 150 70",
    style: {
      enableBackground: "new 0 3 150 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#Gradient_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M76.9,31.8c-0.1,4.8,4.2,7.4,7.4,9c3.3,1.6,4.5,2.7,4.4,4.1c0,2.2-2.7,3.2-5.1,3.2 c-4.3,0.1-6.8-1.2-8.8-2.1l-1.6,7.2c2,0.9,5.7,1.7,9.4,1.8c8.9,0,14.8-4.4,14.8-11.2c0-8.7-12-9.1-12-13.1 c0-1.2,1.2-2.5,3.6-2.8c1.2-0.1,4.6-0.3,8.4,1.5l1.5-7c-2.1-0.7-4.7-1.5-8-1.5C82.8,20.9,76.9,25.4,76.9,31.8 M113.6,21.5 c-1.6,0-3,1-3.6,2.4L97.2,54.4h8.9l1.8-4.9h10.9l1,4.9h7.9l-6.8-32.9H113.6 M114.8,30.4l2.6,12.3h-7.1L114.8,30.4 M66,21.5 l-7.1,32.9h8.5l7-32.9H66 M53.4,21.5l-8.8,22.4l-3.6-19c-0.4-2.2-2.1-3.3-3.9-3.3H22.5l-0.2,1c3,0.7,6.3,1.7,8.4,2.8 c1.3,0.7,1.6,1.3,2,2.9l6.8,26.2h9l13.9-32.9H53.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.9187,
    y1: 161.1853,
    x2: 132.1303,
    y2: 161.1853,
    gradientTransform: "matrix(419.708 -154.5691 -154.5691 -419.708 -30421.2207 88095.1953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#212457"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#294DA1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Gradient",
    className: "st0",
    d: "M11.3,25l103.9-38.2l23.6,64.2L34.9,89.1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaicon);
export default __webpack_public_path__ + "static/media/visa.icon.94a88ae9da430b62c7cfccd71b1da2cc.svg";
export { ForwardRef as ReactComponent };